import { request, RespError, handleFormatRes } from '../../utils';
import { QRY_USERACT } from '../../config/url';
export var ActState;
(function (ActState) {
    /** 可参与 */
    ActState[ActState["normal"] = 1] = "normal";
    /** 已参与 */
    ActState[ActState["recieved"] = 2] = "recieved";
    /** 库存不足 */
    ActState[ActState["stockEnd"] = 3] = "stockEnd";
    /** 未开始 */
    ActState[ActState["notStart"] = 4] = "notStart";
    /** 已结束 */
    ActState[ActState["outdate"] = 5] = "outdate";
    /** 单日限额、黑名单 */
    ActState[ActState["block"] = 6] = "block";
})(ActState || (ActState = {}));
// 需要转成 int 型的 key 数组
const needParseIntKey = ['state', 'totalSuccNum', 'userLimit'];
// 需要转成 date 型的 key 数组
const needParseDateKey = [];
/**
 * 活动状态查询接口
 *
 * 查询活动参与状态
 *
 * 接口地址：`/app/promotion/prom_qry_useract.cgi`
 *
 * @param actListid 活动ID
 * @returns
 */
export async function qryUseract({ actListid }) {
    try {
        const isMultipleAct = Array.isArray(actListid);
        // 参数格式化
        const params = {
            t: new Date().getTime(),
            act_listid: isMultipleAct ? actListid.join('_') : actListid,
        };
        // 接口请求
        const result = await request.get(QRY_USERACT, { params });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                let info = undefined;
                if (result.param) {
                    const data = JSON.parse(decodeURIComponent(result.param));
                    if (isMultipleAct) {
                        const revertData = [];
                        for (const value of Object.values(data)) {
                            revertData.push(handleFormatRes({ result: value, needParseIntKey, needParseDateKey }));
                        }
                        info = Array.from(revertData);
                    }
                    else {
                        info = handleFormatRes({
                            result: data[params.act_listid],
                            needParseIntKey,
                            needParseDateKey,
                        });
                    }
                }
                const res = { retcode: result.retcode, retmsg: result.retmsg, info };
                return res;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        throw error;
    }
}
